export default __webpack_public_path__ + "static/media/prospect-illustration.33aceec1.svg";